var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.products.length !== 0)?_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.products),function(seo,code){return _c('WLHomepageItemSeo',{key:code,staticClass:"mt-5",attrs:{"products":seo.products,"domain-name":seo.name,"limit":_vm.limit}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }